import PropTypes from "prop-types";
import React from "react";
import { Button, Glyphicon, Checkbox } from "react-bootstrap";
import { Creatable } from "react-select";
import _ from "lodash";

import AccountActions from "../actions/AccountActions";

import CategoryStore from "../stores/CategoryStore";
import TagStore from "../stores/TagStore";

import AccountingHelper from "../utils/AccountingHelper";
import Api from "../utils/Api";
import DateHelper from "../utils/DateHelper";
import DatePicker from "../utils/DatePicker";

import CategorySelect from "./CategorySelect";
import DescriptionComplete from "./DescriptionComplete";
import InputAmount from "./InputAmount";
import ModalWrapper from "./ModalWrapper";

export default class TransactionMobileEdit extends React.Component
{
	constructor(props)
	{
		super(props);

		let state = TransactionMobileEdit.getStoreState();
		state.loading = true;
		state.saving = false;
		state.multiValue = [];
		state.options = [];

		this.state = state;

		this._onChange = this._onChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleNewLineItem = this.handleNewLineItem.bind(this);
		this.handleNewTagCreate = this.handleNewTagCreate.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleTransactionDateChange = this.handleTransactionDateChange.bind(this);
	}

	static getStoreState()
	{
		return {
			tags: TagStore.getTags(),
		};
	}

	async handleSave()
	{
		const transaction = this.state.transaction;
		transaction.lineItems = this.state.lineItems;

		this.setState({saving: true});
		await AccountActions.saveTransaction(transaction);
		this.handleClose();
	}

	handleClose()
	{
		this.props.onClose();
	}

	handleTransactionDateChange(dateValue)
	{
		const transaction = this.state.transaction;
		transaction.date = dateValue;

		this.setState({transaction});
	}

	handleLineItemDescriptionSelect(lineItem, index, lineItemPrefill)
	{
		lineItem.description = lineItemPrefill.description;
		if (!lineItem.categoryId)
		{
			lineItem.categoryId = lineItemPrefill.categoryId;
			lineItem.isExpense = this.isCategoryExpense(lineItemPrefill.categoryId);
			lineItem.isCreditRefund = false;
			if (lineItem.isExpense && lineItemPrefill.amount > 0)
			{
				lineItem.isCreditRefund = true;
			}
			else if (!lineItem.isExpense && lineItemPrefill.amount < 0)
			{
				lineItem.isCreditRefund = true;
			}
		}
		if (!lineItem.amount)
		{
			lineItem.amount = Math.abs(lineItemPrefill.amount);
		}

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemDescriptionChange(lineItem, index, value)
	{
		lineItem.description = value;

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemCategoryChange(lineItem, index, category)
	{
		lineItem.categoryId = category ? category.id : null;
		lineItem.isExpense = this.isCategoryExpense(lineItem.categoryId);
		lineItem.amount = this.getLineItemSignedValue(lineItem, lineItem.amount);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemAmountChange(lineItem, index, value)
	{
		lineItem.amount = this.getLineItemSignedValue(lineItem, value);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemIsCreditRefundChange(lineItem, index, event)
	{
		lineItem.isCreditRefund = event.target.checked;
		lineItem.amount = this.getLineItemSignedValue(lineItem, lineItem.amount);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({ lineItems });
	}

	handleNewTagCreate(newOption)
	{
		this.setState({ options: this.state.options.concat(newOption) });
	}

	handleTagsChange(lineItem, index, value)
	{
		lineItem.tags = value.map(tag => tag.text);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({ lineItems });
	}

	handleNewLineItem()
	{
		const lineItems = this.state.lineItems;
		lineItems.push({amount: 0, isExpense: true});
		this.setState({lineItems});
	}

	handleLineItemDelete(index)
	{
		const lineItems = this.state.lineItems;
		lineItems.splice(index, 1);
		this.setState({lineItems});
	}

	handleTransactionLoaded(transaction)
	{
		const lineItems = transaction.lineItems;
		delete transaction.lineItems;
		if (lineItems.length < 1)
		{
			lineItems.push({amount: 0});
		}

		lineItems.forEach((lineItem) =>
		{
			if (lineItem.categoryId)
			{
				lineItem.isExpense = this.isCategoryExpense(lineItem.categoryId);
				if ((!lineItem.isExpense && lineItem.amount < 0) || (lineItem.isExpense && lineItem.amount > 0))
				{
					lineItem.isCreditRefund = true;
				}
			}
		});

		this.setState({
			transaction,
			lineItems,
			loading: false
		});
	}

	isCategoryExpense(categoryId)
	{
		const inputCategory = this.categories.find(cat => cat.id === categoryId);
		if (inputCategory && inputCategory.type === Enums.categoryType.expense)
		{
			return true;
		}
		return false;
	}

	getLineItemSignedValue(lineItem, value)
	{
		value = Math.abs(value);
		if ((lineItem.isExpense && !lineItem.isCreditRefund) || (!lineItem.isExpense && lineItem.isCreditRefund))
		{
			value *= -1;
		}
		return value;
	}

	async loadExistingTransaction()
	{
		try
		{
			const transaction = await Api.getTransaction(this.props.transactionId);
			this.handleTransactionLoaded(transaction);
		}
		catch (message)
		{
			// TODO: BA-152 handle error
			console.error(message);
		}
	}

	// Method to setState based upon Store changes
	_onChange()
	{
		this.setState(TransactionMobileEdit.getStoreState());
	}

	componentDidMount()
	{
		this.categories = CategoryStore.getCategories();
		if (!this.props.isNew)
		{
			this.loadExistingTransaction();
		}
		else
		{
			const newTransaction = {
				lineItems: [],
				date: DateHelper.getCurrentDate().toISOString(),
				isNew: true,
				accountId: this.props.accountId
			};
			this.handleTransactionLoaded(newTransaction);
		}

		TagStore.addChangeListener(this._onChange);
	}

	// Remove change listeners from stores
	componentWillUnmount()
	{
		TagStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const categories = this.categories;
		const {currencyId, isNew, numberDecimals} = this.props;
		const {
			transaction,
			lineItems,
			tags,
			options,
			saving,
		} = this.state;

		const tagOptions = [].concat(tags);
		options.forEach(opt =>
		{
			if (!tagOptions.includes(tag => tag.text === opt.text))
			{
				tagOptions.push(opt);
			}
		});

		const totalAmount = _.sumBy(lineItems, lineItem =>
		{
			const value = +lineItem.amount;
			return isNaN(value) ? 0 : value;
		});

		const footerElements = [
			<Button key={0} bsStyle={"primary"} onClick={this.handleSave} disabled={saving}>Save</Button>,
			<Button key={1} onClick={this.handleClose} disabled={saving}>Close</Button>
		];

		return (
			<ModalWrapper
				title={isNew ? "New Transaction" : "Update Transaction"}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
				footerClass={"floating-footer"}
			>
				{this.state.loading ?
					<div className={"text-center"}>
						<Glyphicon glyph={"refresh"} className={"spinning"} />
						<span> Loading</span>
					</div>
					:
					<div>
						<div className={"form-group row"}>
							<label
								className={"col-sm-4"}
								htmlFor={"splitTransactionDate"}
							>
								Transaction Date
							</label>
							<div className={"col-sm-8"}>
								<DatePicker
									id={"splitTransactionDate"}
									className={"input-sm"}
									value={DateHelper.toISOString(transaction.date)}
									onChange={this.handleTransactionDateChange}
									showClearButton={false}
								/>
							</div>
						</div>
						<div>
							{lineItems.map((lineItem, index) => {
								const multiValue = lineItem.tags ? lineItem.tags.map(tag => { return { text: tag }; }) : [];

								return (
									<div key={index} className={"mobile-transaction-line-item"}>
										<div className={"form-group row"}>
											<label className={"col-xs-4"}>
												<span className={"unselectable"}>Description</span>
											</label>
											<div className={"col-xs-8"}>
												<DescriptionComplete
													value={lineItem.description || ""}
													onSelect={this.handleLineItemDescriptionSelect.bind(this, lineItem, index)}
													onChange={this.handleLineItemDescriptionChange.bind(this, lineItem, index)}
													autoFocus={true}
												/>
											</div>
										</div>
										<div className={"form-group row"}>
											<label className={"col-xs-4"}>
												<span className={"unselectable"}>Category</span>
											</label>
											<div className={"col-xs-8"}>
												<CategorySelect
													onSelect={this.handleLineItemCategoryChange.bind(this, lineItem, index)}
													value={lineItem.categoryId}
													options={categories}
												/>
											</div>
										</div>
										<div className={"form-group row"}>
											<label className={"col-xs-4"}>
												<span className={"unselectable"}>Amount</span>
											</label>
											<div className={"col-xs-8"}>
												<InputAmount
													value={Math.abs(lineItem.amount)}
													onChange={this.handleLineItemAmountChange.bind(this, lineItem, index)}
													numberDecimals={numberDecimals}
												/>
											</div>
										</div>
										<div className={"form-group row"}>
											<label className={"col-xs-4"}>
												<span className={"unselectable"}>Tags</span>
											</label>
											<div className={"col-xs-8"}>
												<Creatable
													className="transactionTagsSelect"
													multi={true}
													options={tagOptions}
													onChange={this.handleTagsChange.bind(this, lineItem, index)}
													onNewOptionClick={this.handleNewTagCreate}
													value={multiValue}
													valueKey="text"
													labelKey="text"
												/>
											</div>
										</div>
										<div className={"form-group row"}>
											<label className={"col-xs-6"}>
												<Checkbox
													defaultChecked={lineItem.isCreditRefund}
													onBlur={this.handleFieldBlur}
													defaultValue={lineItem.isCreditRefund}
													onChange={this.handleLineItemIsCreditRefundChange.bind(this, lineItem, index)}
												>
													{lineItem.isExpense ? "Refund" : "Credit"}
												</Checkbox>
											</label>
											<div className={"col-xs-6"}>
												<Button
													bsSize={"sm"}
													bsStyle={"danger"}
													onClick={this.handleLineItemDelete.bind(this, index)}
												>
													<Glyphicon glyph={"trash"}/>
												</Button>
											</div>
										</div>
									</div>
								);
							})}
						</div>
						<Button bsStyle={"link"} onClick={this.handleNewLineItem}>Add new</Button>
						<div className={"form-group row"}>
							<label className={"col-xs-6"}>
								<span className={"unselectable"}>Total</span>
							</label>
							<div className={"col-xs-6"}>
								{AccountingHelper.formatMoney(totalAmount, currencyId)}
							</div>
						</div>
					</div>
				}
			</ModalWrapper>
		);
	}
}

TransactionMobileEdit.propTypes = {
	onClose: PropTypes.func,
	isNew: PropTypes.bool,
	transactionId: PropTypes.number,
	accountId: PropTypes.number,
	currencyId: PropTypes.number,
	numberDecimals: PropTypes.number,
};



// WEBPACK FOOTER //
// ./Components/components/TransactionMobileEdit.jsx